exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.msg-content.el-tooltip__popper {\r\n  max-width: 900px;\n}\r\n", ""]);

// exports
